import React from 'react';
import styled from 'styled-components';
import colors from '../../../lib/Colors';
import UserAvatar from '../UserAvatar';
import * as PropTypes from 'prop-types';
import fonts from '../../../lib/Fonts';
import Breakpoints from '../../../lib/Breakpoints';
import I18n from 'i18n-js'

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${colors.white};
  padding: 10px 10px 10px 0px;
  box-shadow: 0 2px 4px 0 rgba(230, 230, 230, 0.7);
`;

const StyledContentWrapper = styled.div`
  display: flex;
`

const StyledSupportPhone = styled.h2`
  font-size: 1em;
  color: ${colors.almostBlack};
  font-family: ${fonts.family.workSans};
  margin: auto 10px auto 0;
  font-weight: 300;
`

const StyledPhoneNumber = styled.a`
  color: ${colors.blue}; 
`

const StyledSecondLine = styled.span`
  @media (max-width: ${Breakpoints.tablet}) {
  display: block;
  }
`

const LogoWrapper = styled.a`
  height: 30px;
  width: 140px;
  margin: 0 10px 10px;
`

const Logo = styled.img`
  width: 100%;
`

const Header = ({createRetailer, userFirstName, userLastName}) => {
  return (
    <StyledHeader>
      <LogoWrapper href={'https://www.bevspot.com'}>
        <Logo src={'/static/img/user_auth/logo_with_text.png'} />
      </LogoWrapper>
      <StyledContentWrapper>
        <StyledSupportPhone>{I18n.t('header.help')}
          <StyledSecondLine>
            {' '}{I18n.t('header.secondLine')}{' '}
            <StyledPhoneNumber href='tel:15085709407'>1 (508) 570-9407</StyledPhoneNumber>
          </StyledSecondLine>
        </StyledSupportPhone>
        {createRetailer ? <UserAvatar firstName={userFirstName} lastName={userLastName}/> : null}
      </StyledContentWrapper>
    </StyledHeader>
  )
};

Header.propTypes = {
  createRetailer: PropTypes.bool,
  userFirstName: PropTypes.string,
  userLastName: PropTypes.string,

};
export default Header;
